import React from "react";
import { FiArrowUpRight } from "react-icons/fi"; // Agar arrow icon lagana ho

const SpecimenCard = ({ title, subtitle, imageUrl }) => (
  // Pure group pe cursor trigger lagana hai
  <div className="group relative cursor-pointer overflow-hidden rounded-3xl  md:h-80 w-full transition-all duration-700 ease-out">
    {/* Container with Shape Transition:
      default state (clean square): rectangle shape
      hover state: unique slanted corner shape
    */}
    <div
      className="relative h-full w-full overflow-hidden transition-all duration-700 ease-in-out"
      style={{
        // Default clean square edge (rectangle)
        "--clip-shape": "polygon(0 0, 100% 0, 100% 100%, 100% 100%, 0 100%)",
        // Hover slanted angle shape (from image)
        "--hover-clip-shape":
          "polygon(0 0, 100% 0, 100% 55%, 70% 100%, 0 100%)",
        // Use a simple calc to animate the polygon
        clipPath: "var(--clip-shape)",
      }}
      // Group hover par value update
      onMouseEnter={(e) =>
        (e.currentTarget.style.clipPath = "var(--hover-clip-shape)")
      }
      onMouseLeave={(e) =>
        (e.currentTarget.style.clipPath = "var(--clip-shape)")
      }
    >
      {/* Background Image - stays full and expands subtly */}
      <img
        src={imageUrl}
        alt={title}
        className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
      />

      {/* Overlays */}
      <div className="absolute inset-0 bg-black/30 transition-opacity duration-300 group-hover:bg-black/60" />

      {/* Text Overlay Layer */}
      <div className="absolute inset-0 p-8 flex flex-col justify-start">
        {/* Title: Always visible, moves up a bit on hover */}
        <h3 className="text-white text-2xl font-bold mb-2 transition-transform duration-500 group-hover:-translate-y-2">
          {title}
        </h3>

        {/* Description: Hidden, appears on hover with movement */}
        <p className="text-gray-200 text-sm leading-relaxed opacity-0 transform translate-y-6 transition-all duration-700 delay-100 group-hover:opacity-100 group-hover:translate-y-0 max-w-[80%]">
          {subtitle}
        </p>
      </div>
    </div>

    {/* Floating Arrow Button (Bottom Right):
      Moves 'into view' from bottom-right on hover
    */}
    <div className="absolute bottom-4 right-8 z-10 opacity-0 transform translate-x-4 translate-y-4 transition-all duration-500 delay-150 group-hover:opacity-100 group-hover:translate-x-0 group-hover:translate-y-0">
      <div className="bg-white p-3 rounded-full border border-slate-300 shadow-xl transform transition-all duration-300 group-hover:bg-[#1a365d] group-hover:text-white">
        {/* Icon replaced with text '→' if react-icons is not used */}
        <FiArrowUpRight className="text-xl" />
        {/* <span className="text-xl font-bold">→</span> */}
      </div>
    </div>
  </div>
);

const BrowseBySpecimen = () => {
  const specimens = [
    {
      id: 1,
      title: "Biofluids",
      subtitle:
        "Whole Blood, Plasma (Single & Double Spun), Serum, Urine, Buffy Coat, Synovial Fluid, Pleural/Ascetic Fluids, Bronchoalveolar lavage (BAL) fluid.",
      image: "/images/BrowseType/type1.png",
    },
    {
      id: 2,
      title: "Tissue Samples",
      subtitle: "FFPE Blocks/Slides, Frozen Tissue",
      image: "/images/BrowseType/type2.png",
    },
    {
      id: 3,
      title: "Cells & Blood Components",
      subtitle:
        "Peripheral Blood Mononuclear Cells (PBMCs), Platelets, Synovial Mononuclear Cells (SMNCs)",
      image: "/images/BrowseType/type3.png",
    },
  ];

  return (
    <section className="py-8 md:py-16 px-6 max-w-[1800px] mx-auto">
      <h2 className="text-center text-[24px] md:text-[30px] lg:text-[40px] 2xl:text-[60px]  font-extrabold text-[#183076] mb-12">
        Specimen Type
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8 h-[100vh] md:h-auto">
        {specimens.map((item) => (
          <SpecimenCard
            key={item.id}
            title={item.title}
            subtitle={item.subtitle}
            imageUrl={item.image}
          />
        ))}
      </div>
    </section>
  );
};

export default BrowseBySpecimen;
